<div class="user-mini-card"
     [class.middle]="displayType === 'middle'"
     [class.narrow]="displayType === 'narrow'"
     [class.mobile]="deviceService.isMobile()">
    <div class="header">
      <div class="avatar-wrap">
        <on-ui-cover [cover]="avatar" [attr.data-test]="'userpic'"></on-ui-cover>
      </div>
      <div class="meta">
        <h4 class="name">
          <a [routerLink]="accountRoute" [attr.title]="fullName">{{ fullName }}</a>
          <ng-template [ngIf]="profileVerified" [ngIfElse]="noVerified">
            <app-icon height="16" width="18" file="status" icon="teacher-verify" class="verify"></app-icon>
          </ng-template>

          <ng-template #noVerified>
            <app-icon height="16" width="18" file="status" icon="teacher-no-verify" class="no-verify"></app-icon>
          </ng-template>
        </h4>
        <div class="speak-block">
          <div class="flag-wrap">
            <img *ngIf="countryFlagUrl" [src]="countryFlagUrl" [alt]="countryName" class="flag">
          </div>
          <span class="text">({{ countryName }})</span>
          <div class="separator"></div>
          <ng-template [ngIf]="speakLanguages[0]">
            <span class="text">{{ 'library.user-mini-card.speak-on' | customLocale }}</span>&nbsp;
            <span class="text">{{ speakLanguages[0]?.title }}</span>&nbsp;
            <span *ngIf="speakLanguages.slice(1).length" class="text sky-darker">+{{ speakLanguages.slice(1).length }}</span>
          </ng-template>
        </div>
        <div class="rate-block">
          <app-rating [stats]="stats" [label]="true"></app-rating>
        </div>
      </div>
    </div>

    <div class="info">
      <ng-template [ngIf]="teachingSubjects?.length">
        <div class="subjects-wrap">
          <div *ngFor="let subject of teachingSubjects.slice(0, 2); trackBy: trackByFn" class="subject">{{ subject }}</div>
          <span *ngIf="teachingSubjects.slice(2).length" class="other-subject">+{{ teachingSubjects.slice(2).length }}</span>
        </div>
      </ng-template>

      <p class="about">{{ about }}</p>

      <div class="price-wrap">
        <ng-template [ngIf]="stats && stats.min_price_tier">
          <span class="price-tier-label">{{ 'library.user-mini-card.from' | customLocale }}</span>
          <span class="price-tier">{{ getFormattedPrice(stats.min_price_tier) | async}}</span>
          <span class="price-tier-label">{{ 'library.user-mini-card.price' | customLocale }}</span>
        </ng-template>
      </div>
    </div>
  </div>


